export default "__VITE_ASSET__CAgZ4zmL__"